export const isEnableFullDiagnostic = (userArtist: any) =>
  userArtist?.country === "BR";
